import React from "react";
import useReveal from "../../hooks/useReveal";
import "../../Components/HomePage/HomePage.css";

const AvailableOn = () => {
    useReveal();

    return (
        <section className="hp-available hp-section" style={{ backgroundColor: 'var(--tintcolor)' }}>
            <div className="container">
                <h2 className="hp-available-heading">
                    We are also available on
                </h2>
                <div className="hp-available-row">
                    <div className="hp-available-col reveal">
                        <a
                            href="https://www.amazon.in/stores/KukuNamkeen/page/C337DF88-0254-4F8D-B8BC-0E12C5B755F7?lp_asin=B0DHSCRQKD&ref_=ast_bln"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <img
                                src="/kuku-assets/images/amazon-600px.png"
                                className="hp-platform-img"
                                alt="Amazon"
                            />
                        </a>
                    </div>
                    <div className="hp-available-col reveal">
                        <img
                            src="/kuku-assets/images/zomato-600px.png"
                            className="hp-platform-img"
                            alt="Zomato"
                        />
                    </div>
                    <div className="hp-available-col reveal">
                        <img
                            src="/kuku-assets/images/mirchi-logo-600px.png"
                            className="hp-platform-img"
                            alt="Mirchi"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AvailableOn;
